/* ============================================================
   ANZY HOME — PDP Bundle Builder
   assets/anzy-bundle.js

   Нічого не імпортує, нічого не залежить від теми.
   Усі дані читає з data-атрибутів, які рендерить Liquid.
   Ціни всюди в центах (як у Shopify).
   ============================================================ */
(function () {
  'use strict';

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = '';

    function num(n, precision, thousands, decimal) {
      if (isNaN(n) || n === null) return 0;
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousands || ','));
      var tail = parts[1] ? (decimal || '.') + parts[1] : '';
      return head + tail;
    }

    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : 'amount';

    switch (token) {
      case 'amount':                        value = num(cents, 2, ',', '.'); break;
      case 'amount_no_decimals':            value = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator':   value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':   value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      default:                              value = num(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- component ---------- */
  function BundleBuilder(root) {
    this.root = root;
    this.moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    this.mainPrice = parseInt(root.dataset.mainPrice, 10) || 0;
    this.mainVariantId = root.dataset.mainVariantId || '';
    /* усі варіанти основного товару: id -> ціна в центах */
    try { this.mainVariants = JSON.parse(root.dataset.mainVariants || '{}'); }
    catch (e) { this.mainVariants = {}; }
    if (this.mainVariantId && !(this.mainVariantId in this.mainVariants)) {
      this.mainVariants[this.mainVariantId] = this.mainPrice;
    }
    /* скільки люльок цього товару вже лежить у кошику і на яку суму */
    this.mainInCart = 0;
    this.mainCartSubtotal = 0;
    this.cartDrawerSection = root.dataset.cartDrawerSection || '';

    /* подарунок на верхньому порозі. Його ціна НЕ входить у суму кошика:
       інакше він сам себе дотягував би до порога. Безкоштовним його
       робить автоматична знижка Shopify, фронт лише кладе його в кошик. */
    this.giftAt = parseInt(root.dataset.giftAt, 10) || 0;
    this.giftVariantId = root.dataset.giftVariantId || '';
    this.giftTitle = root.dataset.giftTitle || '';
    this.giftAvailable = root.dataset.giftAvailable !== 'false';
    this.giftValue = parseInt(root.dataset.giftValue, 10) || 0;

    try {
      this.tiers = JSON.parse(root.dataset.tiers || '[]');
    } catch (e) {
      this.tiers = [];
    }
    this.tiers.sort(function (a, b) { return a.at - b.at; });

    this.state = { picked: {}, qty: {}, adding: false, added: false };

    this.el = {
      tierFill:  root.querySelector('[data-anzy-tier-fill]'),
      tierTitle: root.querySelector('[data-anzy-tier-title]'),
      tierNote:  root.querySelector('[data-anzy-tier-note]'),
      dots:      root.querySelectorAll('[data-anzy-tier-dot]'),
      labels:    root.querySelectorAll('[data-anzy-tier-label]'),
      miniFill:  root.querySelector('[data-anzy-mini-fill]'),
      miniMsg:   root.querySelector('[data-anzy-mini-msg]'),
      miniSave:  root.querySelector('[data-anzy-mini-save]'),
      sum:       root.querySelector('[data-anzy-sum]'),
      sumLabel:  root.querySelector('[data-anzy-sum-label]'),
      sumSave:   root.querySelector('[data-anzy-sum-save]'),
      sumTotal:  root.querySelector('[data-anzy-sum-total]'),
      gift:      root.querySelector('[data-anzy-gift]'),
      giftMsg:   root.querySelector('[data-anzy-gift-msg]'),
      giftDot:   root.querySelector('[data-anzy-gift-dot]'),
      giftLabel: root.querySelector('[data-anzy-gift-label]'),
      saveStrip: root.querySelector('[data-anzy-save-strip]'),
      saveTitle: root.querySelector('[data-anzy-save-title]'),
      saveAmt:   root.querySelector('[data-anzy-save-amt]'),
      miniTrack: root.querySelector('.anzy-mini__track'),
      miniRow:   root.querySelector('.anzy-dock__mini'),
      cta:       root.querySelector('[data-anzy-add-bundle]'),
      cards:     Array.prototype.slice.call(root.querySelectorAll('[data-anzy-card]'))
    };

    this.strings = {
      addMore:     root.dataset.strAddMore     || 'Add {gap} more to unlock {pct}% off',
      topTier:     root.dataset.strTopTier     || 'Maximum {pct}% off unlocked',
      ofTarget:    root.dataset.strOfTarget    || '{cart} of {target}',
      alsoUnlocked:root.dataset.strUnlocked    || ' — {pct}% already unlocked',
      almost:      root.dataset.strAlmost      || ' — almost there!',
      miniUnlocked:root.dataset.strMiniUnlocked|| '🎉 {pct}% off applied! Add {gap} more for {next}% off',
      miniPlain:   root.dataset.strMiniPlain   || 'Add {gap} more to get {pct}% off',
      miniTop:     root.dataset.strMiniTop     || '🎉 {pct}% off applied — top tier unlocked',
      youSave:     root.dataset.strYouSave     || 'You save {amount}',
      startSaving: root.dataset.strStartSaving || 'Add an item to start saving',
      totalSavings:root.dataset.strTotalSavings|| 'Your total savings',
      ctaIdle:     root.dataset.strCtaIdle     || 'Add to cart',
      ctaCount:    root.dataset.strCtaCount    || 'Add {n} to cart',
      ctaDone:     root.dataset.strCtaDone     || '✓  Added to cart',
      giftPropLabel: root.dataset.strGiftProp  || 'Free gift',
      giftPropValue: root.dataset.strGiftPropV || 'Unlocked at {at}',
      giftLocked:  root.dataset.strGiftLocked  || 'Free from {at} — {gap} to go',
      giftOn:      root.dataset.strGiftOn      || 'Unlocked — added to your bundle, free',
      tierThenGift:root.dataset.strTierGift    || '{pct}% off applied — add {gap} more for a free {gift}',
      topAll:      root.dataset.strTopAll      || 'Top tier — {pct}% off and your free {gift}',
      saveIdle:    root.dataset.strSaveIdle    || 'Build your bundle — your savings show up here',
      saveOn:      root.dataset.strSaveOn      || 'You are saving on this bundle',
      miniIdle:    root.dataset.strMiniIdle    || 'Add what you need below',
      miniItems:   root.dataset.strMiniItems   || '{n} added to your bundle',
      selectLabel: root.dataset.strSelect      || 'Select',
      selectedLabel: root.dataset.strSelected  || '✓  Selected'
    };

    this.indexVariants();
    this.bind();
    this.initPin();
    this.render();
    this.watchMainVariant();
    this.hydrate();
  }

  /* ---------- прилипання нижньої панелі ----------
     Панель лежить у потоці під бандлом. Прилипає до низу екрана
     лише тоді, коли верхній прогрес-бар уже зник з екрана,
     і відлипає, щойно доскролили до неї самої. */
  BundleBuilder.prototype.initPin = function () {
    var root = this.root;
    if (!root.classList.contains('anzy--sticky')) return;
    if (!('IntersectionObserver' in window)) return;

    var slot = root.querySelector('[data-anzy-dock-slot]');
    var dock = root.querySelector('.anzy-dock');
    var top  = root.querySelector('.anzy-tier')
            || root.querySelector('.anzy-save')
            || root.querySelector('.anzy-bundle');
    if (!slot || !dock || !top) return;

    /* passedTop — верхній бар ПРОЇХАЛИ вгору.
       Саме «проїхали», а не «не видно»: поки бар ще внизу під фолдом,
       його теж не видно, і панель не має прилипати. */
    var passedTop   = false;
    var slotVisible = false;
    var dockH = 0;

    function apply() {
      var pin = passedTop && !slotVisible;
      if (!pin) {
        dockH = dock.offsetHeight || dockH;
        slot.style.minHeight = '';
      } else if (dockH) {
        slot.style.minHeight = dockH + 'px';
      }
      root.classList.toggle('is-pinned', pin);
    }

    new IntersectionObserver(function (e) {
      var r = e[0].boundingClientRect;
      passedTop = !e[0].isIntersecting && r.bottom <= 0;
      apply();
    }, { threshold: 0 }).observe(top);

    new IntersectionObserver(function (e) {
      slotVisible = e[0].isIntersecting;
      apply();
    }, { threshold: 0 }).observe(slot);

    apply();
  };

  BundleBuilder.prototype.t = function (key, vars) {
    var s = this.strings[key] || '';
    Object.keys(vars || {}).forEach(function (k) {
      s = s.split('{' + k + '}').join(vars[k]);
    });
    return s;
  };

  BundleBuilder.prototype.money = function (cents) {
    return formatMoney(Math.round(cents), this.moneyFormat);
  };

  /* ---------- events ---------- */
  BundleBuilder.prototype.bind = function () {
    var self = this;

    /* rail arrows */
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-anzy-scroll]'), function (btn) {
      btn.addEventListener('click', function () {
        var rail = self.root.querySelector('[data-anzy-rail="' + btn.dataset.anzyRailTarget + '"]');
        if (!rail) return;
        var step = (rail.querySelector('[data-anzy-card]') || {}).offsetWidth || 188;
        rail.scrollBy({ left: (btn.dataset.anzyScroll === 'next' ? 1 : -1) * (step + 14), behavior: 'smooth' });
      });
    });

    /* cards */
    this.el.cards.forEach(function (card) {
      var group = card.dataset.group;
      var mode  = card.dataset.mode;

      /* розпродані картки інертні */
      if (card.dataset.available === 'false') return;

      /* селект варіантів (картка = продукт із кількома варіаціями).
         Міняє variantId + price на самій картці, переносить кількість
         зі старого варіанта на новий і перемальовує ціну. */
      var sel = card.querySelector('[data-anzy-sel]');
      if (sel) {
        var selBtn  = sel.querySelector('[data-anzy-sel-btn]');
        var selVal  = sel.querySelector('[data-anzy-sel-val]');
        var selList = sel.querySelector('[data-anzy-sel-list]');
        var opts    = [].slice.call(sel.querySelectorAll('[data-anzy-sel-opt]'));

        /* рейка скролиться по горизонталі, тому вона обрізає абсолютний
           дропдаун. На час відкриття знімаємо обрізку. */
        var rail = card.closest ? card.closest('.anzy-rail') : null;

        var close = function () {
          sel.classList.remove('is-open');
          selList.hidden = true;
          selBtn.setAttribute('aria-expanded', 'false');
          if (rail && !rail.querySelector('[data-anzy-sel].is-open')) {
            rail.classList.remove('has-open');
          }
        };
        var open = function () {
          /* одночасно відкритий лише один дропдаун */
          var others = self.root.querySelectorAll('[data-anzy-sel].is-open');
          for (var i = 0; i < others.length; i++) {
            if (others[i] !== sel) {
              others[i].classList.remove('is-open');
              var l = others[i].querySelector('[data-anzy-sel-list]');
              var b = others[i].querySelector('[data-anzy-sel-btn]');
              if (l) l.hidden = true;
              if (b) b.setAttribute('aria-expanded', 'false');
            }
          }
          var rails = self.root.querySelectorAll('.anzy-rail.has-open');
          for (var r = 0; r < rails.length; r++) rails[r].classList.remove('has-open');
          sel.classList.add('is-open');
          selList.hidden = false;
          selBtn.setAttribute('aria-expanded', 'true');
          if (rail) rail.classList.add('has-open');
        };

        /* стартовий підпис — з позначеної опції */
        var initial = sel.querySelector('[data-anzy-sel-opt].is-on') || opts[0];
        if (initial && selVal) selVal.textContent = initial.textContent.trim();

        var pick = function (opt) {
          var oldId = card.dataset.variantId;
          var newId = opt.dataset.value;

          opts.forEach(function (o) {
            o.classList.toggle('is-on', o === opt);
            o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
          });
          if (selVal) selVal.textContent = opt.textContent.trim();

          card.dataset.variantId = newId;
          card.dataset.price = opt.dataset.price;

          /* посилання з назви веде на щойно обраний колір */
          var link = card.querySelector('.anzy-card__name--link');
          if (link) {
            var base = link.getAttribute('href').split('?')[0];
            link.setAttribute('href', base + '?variant=' + newId);
          }
          card.dataset.compare = opt.dataset.compare || '0';

          if (mode === 'pick') {
            if (self.state.picked[group] === oldId) self.state.picked[group] = newId;
          } else {
            var carried = self.state.qty[oldId] || 0;
            delete self.state.qty[oldId];
            if (carried) self.state.qty[newId] = carried;
          }

          /* фото картки має відповідати обраній опції */
          if (opt.dataset.img) {
            var wrap = card.querySelector('.anzy-card__img');
            var pic = wrap ? wrap.querySelector('img') : null;
            if (!pic && wrap) {
              pic = document.createElement('img');
              pic.loading = 'lazy';
              pic.alt = '';
              wrap.appendChild(pic);
            }
            if (pic) {
              pic.removeAttribute('sizes');
              if (opt.dataset.imgSrcset) {
                pic.srcset = opt.dataset.imgSrcset;
                pic.sizes = '200px';
              } else {
                pic.removeAttribute('srcset');
              }
              pic.src = opt.dataset.img;
            }
          }

          var now = card.querySelector('[data-anzy-price-now]');
          var was = card.querySelector('[data-anzy-price-was]');
          if (now && opt.dataset.newPrice) now.textContent = opt.dataset.newPrice;
          if (was) {
            /* у варіанта може не бути compare at price — тоді закресленої ціни нема */
            var old = opt.dataset.oldPrice || '';
            was.textContent = old;
            was.hidden = !old;
          }

          self.state.added = false;
          close();
          self.render();
        };

        selBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          if (sel.classList.contains('is-open')) { close(); } else { open(); }
        });
        selBtn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault(); e.stopPropagation();
            if (sel.classList.contains('is-open')) { close(); } else { open(); }
          }
          if (e.key === 'Escape') close();
        });

        opts.forEach(function (opt) {
          opt.addEventListener('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            pick(opt);
          });
        });

        /* клік поза дропдауном закриває; клік усередині не чіпає pick-картку */
        sel.addEventListener('click', function (e) { e.stopPropagation(); });
        document.addEventListener('click', close);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') close();
        });
      }

      if (mode === 'pick') {
        card.addEventListener('click', function () {
          var id = card.dataset.variantId;
          self.state.picked[group] = self.state.picked[group] === id ? null : id;
          self.state.added = false;
          self.render();
        });
      } else {
        var inc = card.querySelector('[data-anzy-inc]');
        var dec = card.querySelector('[data-anzy-dec]');
        if (inc) inc.addEventListener('click', function () { self.bump(card.dataset.variantId, 1); });
        if (dec) dec.addEventListener('click', function () { self.bump(card.dataset.variantId, -1); });
      }
    });

    /* gallery */
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-anzy-thumb]'), function (thumb, i, all) {
      thumb.addEventListener('click', function () {
        var main = self.root.querySelector('[data-anzy-gal-main]');
        var counter = self.root.querySelector('[data-anzy-gal-counter]');
        if (main && thumb.dataset.full) main.src = thumb.dataset.full;
        if (counter) counter.textContent = (i + 1) + ' / ' + all.length;
        Array.prototype.forEach.call(all, function (t, j) {
          t.setAttribute('aria-current', String(i === j));
        });
      });
    });

    /* add bundle */
    if (this.el.cta) {
      this.el.cta.addEventListener('click', function () { self.syncCart(); });
    }
  };

  BundleBuilder.prototype.bump = function (variantId, delta) {
    var n = (this.state.qty[variantId] || 0) + delta;
    this.state.qty[variantId] = Math.max(0, n);
    this.state.added = false;
    this.render();
  };

  /* ---------- totals ---------- */
  BundleBuilder.prototype.totals = function () {
    var self = this;
    var cmpSavings = 0, addons = 0, count = 0;

    this.el.cards.forEach(function (card) {
      var id = card.dataset.variantId;
      /* price — те, що людина реально платить (Shopify price варіанта)
         compare — compare at price; різниця і є економія. Нічого не вигадуємо. */
      var price = parseInt(card.dataset.price, 10) || 0;
      var compare = parseInt(card.dataset.compare, 10) || 0;
      var n = card.dataset.mode === 'pick'
        ? (self.state.picked[card.dataset.group] === id ? 1 : 0)
        : (self.state.qty[id] || 0);
      if (!n) return;
      count += n;
      if (compare > price) cmpSavings += (compare - price) * n;
      addons += price * n;
    });

    var cart = this.mainPart() + addons;
    var reached = this.tiers.filter(function (t) { return cart >= t.at; });
    var current = reached.length ? reached[reached.length - 1] : null;
    var next = null;
    for (var i = 0; i < this.tiers.length; i++) {
      if (cart < this.tiers[i].at) { next = this.tiers[i]; break; }
    }

    /* ЕКОНОМІЯ — одне джерело, щоб панель не суперечила сама собі.
       Є пороги → економія це і є знижка порогу від суми кошика,
       рівно те, що потім спише автоматична знижка Shopify.
       Порогів нема → рахуємо різницю compare at price.
       Обидва разом не складаємо: це різні знижки, сума ввела б в оману. */
    var savings = this.tiers.length
      ? (current ? Math.floor(cart * current.pct / 100) : 0)  /* Shopify округлює знижку вниз */
      : cmpSavings;

    var giftOn = this.giftAt > 0 && !!this.giftVariantId && this.giftAvailable && cart >= this.giftAt;

    /* «You save» = знижка порогу + вартість подарунка, як «Total savings»
       у шухляді й на чекауті. До сплати подарунок не впливає: він $0. */
    var giftSave = giftOn ? this.giftValue : 0;

    /* На кнопці — скільки штук реально поїде в кошик: допродажі
       плюс люлька, якщо її там ще нема. Подарунок не рахуємо. */
    var ctaCount = count ? count + (this.mainInCart > 0 ? 0 : 1) : 0;

    return {
      giftOn: giftOn,
      giftGap: this.giftAt > cart ? this.giftAt - cart : 0,
      savings: savings + giftSave,
      cart: cart,          /* сума до знижки */
      payable: cart - savings,  /* стільки буде в кошику */
      count: count,
      ctaCount: ctaCount,
      current: current,
      next: next,
      gap: next ? next.at - cart : 0
    };
  };

  /* ---------- render ---------- */
  BundleBuilder.prototype.render = function () {
    var t = this.totals();
    this.saveDraft();
    this.renderCards();
    this.renderTier(t);
    this.renderGift(t);
    this.renderDock(t);
  };

  BundleBuilder.prototype.renderCards = function () {
    var self = this;
    this.el.cards.forEach(function (card) {
      var id = card.dataset.variantId;
      var isPick = card.dataset.mode === 'pick';
      var q = self.state.qty[id] || 0;
      var on = isPick ? self.state.picked[card.dataset.group] === id : q > 0;

      card.classList.toggle('is-on', !!on);

      if (isPick) {
        var cta = card.querySelector('[data-anzy-cta]');
        if (cta) cta.textContent = on ? self.strings.selectedLabel : self.strings.selectLabel;
      } else {
        var val = card.querySelector('[data-anzy-qty]');
        var dec = card.querySelector('[data-anzy-dec]');
        if (val) { val.textContent = q; val.classList.toggle('is-on', q > 0); }
        if (dec) dec.classList.toggle('is-live', q > 0);
      }
    });
  };

  BundleBuilder.prototype.renderTier = function (t) {
    if (!this.tiers.length || !this.el.tierFill) return;
    var max = this.tiers[this.tiers.length - 1].at;
    if (this.giftAt > max) max = this.giftAt;
    var self = this;

    this.el.tierFill.style.width = Math.min(100, t.cart / max * 100) + '%';

    if (this.el.tierTitle) {
      var topPct = this.tiers[this.tiers.length - 1].pct;
      var txt;
      if (t.next) {
        /* попереду ще відсотковий поріг */
        txt = this.t('addMore', { gap: this.money(t.gap), pct: t.next.pct });
      } else if (this.giftAt > 0 && this.giftVariantId && this.giftAvailable && !t.giftOn) {
        /* відсотки вичерпані, але попереду подарунок — не кажемо «максимум» */
        txt = this.t('tierThenGift', {
          pct: topPct, gap: this.money(t.giftGap), gift: this.giftTitle
        });
      } else if (t.giftOn) {
        txt = this.t('topAll', { pct: topPct, gift: this.giftTitle });
      } else {
        txt = this.t('topTier', { pct: topPct });
      }
      this.el.tierTitle.textContent = txt;
    }

    if (this.el.tierNote) {
      var note;
      if (t.next) {
        note = this.t('ofTarget', { cart: this.money(t.cart), target: this.money(t.next.at) });
        if (t.current)      note += this.t('alsoUnlocked', { pct: t.current.pct });
        else if (t.gap <= 4000) note += this.strings.almost;
      } else {
        note = this.money(t.cart);
      }
      this.el.tierNote.textContent = note;
      this.el.tierNote.classList.toggle('is-on', !!t.current);
    }

    Array.prototype.forEach.call(this.el.dots, function (dot, i) {
      var tier = self.tiers[i];
      if (!tier) return;
      var unlocked = t.cart >= tier.at;
      var isNext = t.next && t.next.at === tier.at;
      dot.classList.toggle('is-on', unlocked);
      dot.classList.toggle('is-next', !unlocked && !!isNext);
    });

    Array.prototype.forEach.call(this.el.labels, function (label, i) {
      var tier = self.tiers[i];
      if (!tier) return;
      var unlocked = t.cart >= tier.at;
      var isNext = t.next && t.next.at === tier.at;
      label.classList.toggle('is-on', unlocked);
      label.classList.toggle('is-next', !unlocked && !!isNext);
    });
  };

  BundleBuilder.prototype.renderDock = function (t) {
    var top = this.tiers.length ? this.tiers[this.tiers.length - 1].pct : 0;

    /* Порогів нема (у налаштуваннях 0). Сама смужка прогресу без порогів
       безглузда, але рядок з економією лишається — і зверху, і внизу. */
    if (!this.tiers.length) {
      if (this.el.miniRow)   this.el.miniRow.hidden = false;
      if (this.el.miniTrack) this.el.miniTrack.hidden = true;
      if (this.el.miniMsg) {
        this.el.miniMsg.textContent = t.count
          ? this.t('miniItems', { n: t.count })
          : this.strings.miniIdle;
      }
      if (this.el.miniSave) {
        this.el.miniSave.textContent = t.savings > 0
          ? this.t('youSave', { amount: this.money(t.savings) })
          : '';
      }
      if (this.el.saveStrip) this.el.saveStrip.hidden = false;
      this.renderSaveStrip(t);
      this.renderDockSum(t);
      return;
    }
    /* пороги є — працює прогрес-бар, окрема плашка економії не потрібна */
    if (this.el.saveStrip) this.el.saveStrip.hidden = true;
    if (this.el.miniRow)   this.el.miniRow.hidden = false;
    if (this.el.miniTrack) this.el.miniTrack.hidden = false;

    if (this.el.miniFill) {
      var base = t.current ? t.current.at : 0;
      this.el.miniFill.style.width = t.next
        ? Math.min(100, (t.cart - base) / (t.next.at - base) * 100) + '%'
        : '100%';
    }

    if (this.el.miniMsg) {
      this.el.miniMsg.textContent = t.next
        ? (t.current
            ? this.t('miniUnlocked', { pct: t.current.pct, gap: this.money(t.gap), next: t.next.pct })
            : this.t('miniPlain', { gap: this.money(t.gap), pct: t.next.pct }))
        : (this.giftAt > 0 && this.giftVariantId && this.giftAvailable
            ? (t.giftOn
                ? this.t('topAll', { pct: top, gift: this.giftTitle })
                : this.t('tierThenGift', { pct: top, gap: this.money(t.giftGap), gift: this.giftTitle }))
            : this.t('miniTop', { pct: top }));
    }

    if (this.el.miniSave) {
      this.el.miniSave.textContent = this.t('youSave', { amount: this.money(t.savings) });
    }

    this.renderDockSum(t);
  };

  BundleBuilder.prototype.renderGift = function (t) {
    if (!this.el.gift) return;
    /* розпроданий подарунок не обіцяємо */
    if (!this.giftAvailable) {
      this.el.gift.hidden = true;
      if (this.el.giftDot)   this.el.giftDot.hidden = true;
      if (this.el.giftLabel) this.el.giftLabel.hidden = true;
      return;
    }
    this.el.gift.hidden = false;
    this.el.gift.classList.toggle('is-on', t.giftOn);
    if (this.el.giftDot)   this.el.giftDot.classList.toggle('is-on', t.giftOn);
    if (this.el.giftLabel) this.el.giftLabel.classList.toggle('is-on', t.giftOn);
    if (this.el.giftMsg) {
      this.el.giftMsg.textContent = t.giftOn
        ? this.strings.giftOn
        : this.t('giftLocked', {
            at: this.money(this.giftAt),
            gap: this.money(t.giftGap)
          });
    }
  };

  /* плашка економії над бандлом (коли порогів нема) */
  BundleBuilder.prototype.renderSaveStrip = function (t) {
    if (!this.el.saveTitle) return;
    var on = t.savings > 0;
    if (this.el.saveStrip) this.el.saveStrip.classList.toggle('is-on', on);
    this.el.saveTitle.textContent = on ? this.strings.saveOn : this.strings.saveIdle;
    if (this.el.saveAmt) this.el.saveAmt.textContent = on ? this.money(t.savings) : '';
  };

  BundleBuilder.prototype.renderDockSum = function (t) {
    var any = t.count > 0;
    var hasSavings = t.savings > 0;
    if (this.el.sum)      this.el.sum.classList.toggle('is-on', hasSavings);
    if (this.el.sumLabel) this.el.sumLabel.textContent = hasSavings ? this.strings.totalSavings : this.strings.startSaving;
    if (this.el.sumSave)  this.el.sumSave.textContent = this.money(t.savings);
    /* показуємо суму ПІСЛЯ знижки — те саме число, що буде в кошику */
    if (this.el.sumTotal) this.el.sumTotal.textContent = this.money(t.payable);

    if (this.el.cta) {
      this.el.cta.classList.toggle('is-on', any);
      this.el.cta.disabled = this.state.adding;
      if (this.state.adding) {
        this.el.cta.innerHTML = '<span class="anzy-spinner"></span>';
      } else if (this.state.added) {
        this.el.cta.textContent = this.strings.ctaDone;
      } else {
        this.el.cta.textContent = any ? this.t('ctaCount', { n: t.ctaCount }) : this.strings.ctaIdle;
      }
    }
  };

  /* ---------- cart ---------- */
  /* ============================================================
     КОШИК
     Блок дзеркалить кошик, а не додає наосліп. Кнопка не «додати»,
     а «привести кошик до того, що показано». Через це:
       • подвійне натискання не подвоює кількість
       • подарунок зникає сам, коли сума впала нижче порогу
       • оновлення сторінки нічого не збиває
     ============================================================ */

  BundleBuilder.prototype.shopRoot = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  BundleBuilder.prototype.fetchCart = function () {
    return fetch(this.shopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  };

  BundleBuilder.prototype.post = function (path, body) {
    return fetch(this.shopRoot() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.status && d.description) throw new Error(d.description);
        return d;
      });
  };

  /* усі варіанти, якими блок має право керувати. Чуже в кошику не чіпаємо. */
  BundleBuilder.prototype.indexVariants = function () {
    var idx = {}, own = {};
    Object.keys(this.mainVariants).forEach(function (vid) { own[vid] = true; });
    if (this.giftVariantId) own[String(this.giftVariantId)] = true;
    this.el.cards.forEach(function (card) {
      idx[String(card.dataset.variantId)] = card;
      own[String(card.dataset.variantId)] = true;
      var opts = card.querySelectorAll('[data-anzy-sel-opt]');
      for (var i = 0; i < opts.length; i++) {
        idx[String(opts[i].dataset.value)] = card;
        own[String(opts[i].dataset.value)] = true;
      }
    });
    this.variantIndex = idx;
    this.ownVariants = own;
  };

  /* ---------- відновлення стану з кошика ---------- */
  BundleBuilder.prototype.hydrate = function () {
    var self = this;
    this.fetchCart()
      .then(function (cart) { self.applyCart(cart); })
      .catch(function () { self.loadDraft(); })
      .then(function () { self.render(); });
  };

  BundleBuilder.prototype.applyCart = function (cart) {
    var self = this;
    var found = false;

    this.state.qty = {};
    this.state.picked = {};
    this.mainInCart = 0;
    this.mainCartSubtotal = 0;
    this.foreignGift = false;

    (cart.items || []).forEach(function (line) {
      var vid = String(line.variant_id);
      if (!self.ownVariants[vid]) return;
      if (self.isMain(vid)) {
        self.mainInCart += line.quantity;
        self.mainCartSubtotal += self.linePrice(line);
        found = true;
        return;
      }
      if (self.giftVariantId && vid === String(self.giftVariantId)) {
        /* ковдру міг покласти сам покупець, щоб купити. Наш рядок позначений
           підписом; чужий — ні, і чіпати його ми не маємо права. */
        var props = line.properties || {};
        if (!props[self.strings.giftPropLabel]) self.foreignGift = true;
        return;
      }

      var card = self.variantIndex[vid];
      if (!card) return;
      found = true;

      /* у кошику може лежати інший варіант цієї ж картки — перемикаємо картку на нього */
      if (String(card.dataset.variantId) !== vid) {
        var opt = card.querySelector('[data-anzy-sel-opt][data-value="' + vid + '"]');
        if (opt) opt.click();
      }
      if (card.dataset.mode === 'pick') self.state.picked[card.dataset.group] = vid;
      else self.state.qty[vid] = line.quantity;
    });

    /* кошик порожній — показуємо те, що людина натикала до оновлення сторінки */
    if (!found) this.loadDraft();
  };

  /* ---------- чернетка вибору в браузері ---------- */
  BundleBuilder.prototype.draftKey = function () {
    return 'anzy-bundle:' + (this.mainVariantId || 'x');
  };

  BundleBuilder.prototype.saveDraft = function () {
    try {
      localStorage.setItem(this.draftKey(), JSON.stringify({
        qty: this.state.qty, picked: this.state.picked, t: Date.now()
      }));
    } catch (e) { /* приватний режим або заблоковане сховище */ }
  };

  BundleBuilder.prototype.loadDraft = function () {
    try {
      var raw = localStorage.getItem(this.draftKey());
      if (!raw) return;
      var d = JSON.parse(raw);
      if (!d || !d.t || Date.now() - d.t > 86400000) return;  /* доба */
      this.state.qty = d.qty || {};
      this.state.picked = d.picked || {};
      this.applySelections();
    } catch (e) { /* биті дані — просто ігноруємо */ }
  };

  /* Якщо у відновленому стані лежить варіант, відмінний від того, що зараз
     показує картка, треба перемкнути саму картку — інакше людина побачить
     одну опцію, а в кошик поїде інша. */
  BundleBuilder.prototype.applySelections = function () {
    var self = this;
    var ids = Object.keys(this.state.qty);
    Object.keys(this.state.picked).forEach(function (g) { ids.push(self.state.picked[g]); });

    ids.forEach(function (vid) {
      var card = self.variantIndex[String(vid)];
      if (!card || String(card.dataset.variantId) === String(vid)) return;
      var opt = card.querySelector('[data-anzy-sel-opt][data-value="' + vid + '"]');
      if (opt) opt.click();
    });
  };

  /* ---------- синхронізація ---------- */
  /* ---------- основний товар (люлька) ---------- */
  BundleBuilder.prototype.isMain = function (vid) {
    return Object.prototype.hasOwnProperty.call(this.mainVariants, String(vid));
  };

  /* ціна рядка ДО знижок — саме від неї Shopify рахує пороги */
  BundleBuilder.prototype.linePrice = function (line) {
    if (typeof line.original_line_price === 'number') return line.original_line_price;
    return (line.original_price || line.price || 0) * (line.quantity || 0);
  };

  /* Варіант, який покупець ЗАРАЗ обрав у селекторі теми (колір люльки).
     Беремо з форми товару теми; запасні варіанти — ?variant= в адресі
     і варіант, з яким сторінка завантажилась. */
  BundleBuilder.prototype.currentMainVariant = function () {
    var self = this;
    /* 1) головний селект форми теми — тема пише в нього id при кожній зміні кольору */
    var sels = document.querySelectorAll('select.original-selector[name="id"]');
    for (var k = 0; k < sels.length; k++) {
      if (!self.root.contains(sels[k]) && sels[k].value && self.isMain(sels[k].value)) return String(sels[k].value);
    }
    /* 2) будь-яка форма додавання в кошик з id люльки */
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (self.root.contains(forms[i])) continue;
      var input = forms[i].querySelector('[name="id"]');
      if (input && input.value && self.isMain(input.value)) return String(input.value);
    }
    var m = /[?&]variant=(\d+)/.exec(window.location.search);
    if (m && self.isMain(m[1])) return m[1];
    return String(this.mainVariantId);
  };

  /* Скільки люлька додає до суми бандла:
     лежить у кошику — рахуємо те, що реально в кошику (хоч 1, хоч 2, будь-якого кольору);
     ще не лежить — рахуємо обраний зараз варіант, одна штука. */
  BundleBuilder.prototype.mainPart = function () {
    if (this.mainInCart > 0) return this.mainCartSubtotal;
    var v = this.currentMainVariant();
    return parseInt(this.mainVariants[v], 10) || this.mainPrice;
  };

  /* Тема міняє колір без перезавантаження сторінки — стежимо, щоб
     ціна люльки в сумі бандла відповідала обраному кольору. */
  BundleBuilder.prototype.watchMainVariant = function () {
    var self = this;
    var last = this.currentMainVariant();
    function check() {
      var now = self.currentMainVariant();
      if (now !== last) { last = now; self.render(); }
    }
    document.addEventListener('change', function () { setTimeout(check, 60); }, true);
    document.addEventListener('click',  function () { setTimeout(check, 120); }, true);
    window.addEventListener('popstate', check);
  };

  /* ---------- синхронізація ---------- */
  BundleBuilder.prototype.syncCart = function () {
    if (this.state.adding) return;
    var self = this;

    this.state.adding = true;
    this.render();

    this.fetchCart()
      .then(function (cart) {
        var items = cart.items || [];

        /* Люлька: якщо будь-який її варіант уже в кошику — не чіпаємо взагалі.
           Покупець сам обрав колір і кількість. Якщо нема — кладемо ту, що
           обрана зараз у селекторі, одну. */
        var mainLines = items.filter(function (l) { return self.isMain(l.variant_id); });
        var mainSub = mainLines.reduce(function (a, l) { return a + self.linePrice(l); }, 0);
        var addMain = mainLines.length ? null : self.currentMainVariant();
        var mainPartNow = mainLines.length ? mainSub : (parseInt(self.mainVariants[addMain], 10) || self.mainPrice);

        /* допродажі — з блоку */
        var want = {};
        var addonsSum = 0;
        self.el.cards.forEach(function (card) {
          var id = String(card.dataset.variantId);
          var n = card.dataset.mode === 'pick'
            ? (self.state.picked[card.dataset.group] === id ? 1 : 0)
            : (self.state.qty[id] || 0);
          if (n > 0) {
            want[id] = (want[id] || 0) + n;
            addonsSum += (parseInt(card.dataset.price, 10) || 0) * n;
          }
        });

        /* подарунок вирішуємо по свіжому кошику, а не по припущеннях блоку */
        var qualifying = mainPartNow + addonsSum;
        var giftOn = self.giftAt > 0 && !!self.giftVariantId && self.giftAvailable && qualifying >= self.giftAt;
        var foreignGift = items.some(function (l) {
          return String(l.variant_id) === String(self.giftVariantId) &&
                 !((l.properties || {})[self.strings.giftPropLabel]);
        });
        if (self.giftVariantId && !foreignGift) want[String(self.giftVariantId)] = giftOn ? 1 : 0;

        var updates = {};
        var adds = [];
        var seen = {};

        items.forEach(function (line) {
          var vid = String(line.variant_id);
          if (!self.ownVariants[vid]) return;               /* чуже не чіпаємо */
          if (self.isMain(vid)) return;                      /* люльку не чіпаємо */
          if (foreignGift && vid === String(self.giftVariantId)) return;
          seen[vid] = true;
          var target = want[vid] || 0;
          if (target !== line.quantity) updates[line.key] = target;
        });

        Object.keys(want).forEach(function (vid) {
          if (seen[vid] || want[vid] <= 0) return;
          var item = { id: Number(vid), quantity: want[vid] };
          if (self.giftVariantId && vid === String(self.giftVariantId)) {
            item.properties = {};
            item.properties[self.strings.giftPropLabel] =
              self.t('giftPropValue', { at: self.money(self.giftAt) });
          }
          adds.push(item);
        });
        if (addMain) adds.unshift({ id: Number(addMain), quantity: 1 });

        var chain = Promise.resolve();
        if (Object.keys(updates).length) {
          chain = chain.then(function () { return self.post('cart/update.js', { updates: updates }); });
        }
        if (adds.length) {
          chain = chain.then(function () { return self.post('cart/add.js', { items: adds }); });
        }
        return chain;
      })
      .then(function () { return self.fetchCart(); })
      .then(function (cart) { return self.applyTierCode(cart); })
      .then(function (cart) {
        self.applyCart(cart);
        self.updateHeaderCount(cart);
        return self.openDrawerFresh();
      })
      .then(function () { self.state.added = true; })
      .catch(function (err) { console.error('[anzy-bundle] cart sync failed:', err); })
      .finally(function () { self.state.adding = false; self.render(); });
  };

  /* ---------- промокод порогу ----------
     5% / 10% — промокоди на замовлення. Підставляємо в кошик той, що
     відповідає сумі бандла в кошику (люлька + товари блоку, без подарунка).
     Чужі промокоди покупця не чіпаємо, міняємо тільки свої. */
  BundleBuilder.prototype.cartCodes = function (cart) {
    var out = [];
    function add(c) {
      if (!c) return;
      c = String(c).trim();
      if (c && out.map(function (x) { return x.toUpperCase(); }).indexOf(c.toUpperCase()) < 0) out.push(c);
    }
    (cart.discount_codes || []).forEach(function (d) { add(d && d.code); });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (a && a.type === 'discount_code') add(a.title);
    });
    (cart.items || []).forEach(function (l) {
      (l.line_level_discount_allocations || []).forEach(function (al) {
        var a = al && al.discount_application;
        if (a && a.type === 'discount_code') add(a.title);
      });
    });
    return out;
  };

  BundleBuilder.prototype.applyTierCode = function (cart) {
    var self = this;
    var ours = this.tiers.map(function (t) { return String(t.code || '').toUpperCase(); })
                         .filter(Boolean);
    if (!ours.length) return Promise.resolve(cart);

    var sum = 0;
    (cart.items || []).forEach(function (l) {
      var vid = String(l.variant_id);
      if (vid === String(self.giftVariantId)) return;
      if (self.isMain(vid) || self.ownVariants[vid]) sum += self.linePrice(l);
    });
    var tier = null;
    this.tiers.forEach(function (t) { if (sum >= t.at && t.code) tier = t; });

    var current = this.cartCodes(cart);
    var keep = current.filter(function (c) { return ours.indexOf(c.toUpperCase()) < 0; });
    var next = keep.concat(tier ? [tier.code] : []);

    var same = next.length === current.length && next.every(function (c) {
      return current.map(function (x) { return x.toUpperCase(); }).indexOf(c.toUpperCase()) >= 0;
    });
    if (same) return Promise.resolve(cart);

    return this.post('cart/update.js', { discount: next.join(',') })
      .then(function () { return self.fetchCart(); })
      .catch(function (e) { console.warn('[anzy-bundle] discount code:', e); return cart; });
  };

  /* Лічильник у хедері теми. Їхній дровер оновлює його тільки при зміні
     кількості всередині дровера, тож після нашого додавання робимо це самі. */
  BundleBuilder.prototype.updateHeaderCount = function (cart) {
    var n = cart.item_count || 0;
    var els = document.querySelectorAll('.cart [data-spark="b2c-only"], .cart .cart-count, [data-cart-count]');
    for (var i = 0; i < els.length; i++) els[i].textContent = n;
    var links = document.querySelectorAll('.cart .text-link');
    for (var j = 0; j < links.length; j++) {
      var t = links[j].textContent;
      if (/\(\d+\)/.test(t)) links[j].textContent = t.replace(/\(\d+\)/, n > 0 ? '(' + n + ')' : '').trim();
      else if (n > 0) links[j].textContent = t.trim() + ' (' + n + ')';
    }
  };

  /* Відкрити дровер зі свіжим вмістом. У теми AnzyHome свій дровер з
     публічною функцією window.openCartDrawer: вона сама перетягує HTML
     дровера і відкриває його. Якщо її нема — стандартний шлях. */
  BundleBuilder.prototype.openDrawerFresh = function () {
    if (typeof window.openCartDrawer === 'function') {
      try { window.openCartDrawer(); } catch (e) { /* не валимо синхронізацію через тему */ }
      return Promise.resolve();
    }

    var id = this.cartDrawerSection;
    function open() {
      var drawer = document.querySelector('cart-drawer') || document.querySelector('[data-cart-drawer]');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else if (drawer) drawer.classList.add('active', 'is-open');
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'anzy-bundle' } })
      );
    }
    if (!id) { open(); return Promise.resolve(); }

    return fetch(this.shopRoot() + '?sections=' + encodeURIComponent(id), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[id];
        if (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('#' + id) ||
                      parsed.querySelector('.drawer__inner') ||
                      parsed.body.firstElementChild;
          var live = document.querySelector('#' + id) ||
                     document.querySelector('.drawer__inner');
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        }
        open();
      })
      .catch(function () { open(); });
  };

  /* ---------- init ---------- */
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-anzy-bundle]'), function (root) {
      if (root.__anzyReady) return;
      root.__anzyReady = true;
      new BundleBuilder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* переініціалізація після зміни секції в Theme Editor */
  document.addEventListener('shopify:section:load', init);
})();